export default "__VITE_ASSET__995cbf9e__"